import home from 'html/home/home.html';

const DEEP_LINK_BASE_PATH = {
  HOME_PICTURE_DAY_ID: '/pictureDayId/:identifier',
  HOME_ACCESS_CODE: '/accessCredentials/:identifier/:accessCode'
};

const DEEP_LINK_PATH = {
  '': '',
  _PACKAGE: '/package/:skuCode',
  _ADDON: '/addon/:skuCode',
  _SKU_SET: '/skuSet/:setName'
};

const EMAIL_LINK_PATH = {
  _EMAIL: '/email/:email'
};

function getDeepLinkPaths() {
  const paths = {};

  Object.entries(DEEP_LINK_BASE_PATH).forEach(([baseKey, basePath]) => {
    Object.entries(DEEP_LINK_PATH).forEach(([key, path]) => {
      paths[`${baseKey}${key}`] = `${basePath}${path}`;
    });
  });

  return paths;
}

function getEmailLinkPaths() {
  const paths = {};

  Object.entries(DEEP_LINK_BASE_PATH).forEach(([baseKey, basePath]) => {
    Object.entries(EMAIL_LINK_PATH).forEach(([key, path]) => {
      paths[`${baseKey}${key}`] = `${basePath}${path}`;
    });
  });

  return paths;
}

const HOME_PATHS = {
  HOME: '/',
  HOME_STUDENT_ID: '/studentId/:email',
  HOME_SAVED_CART_EMAIL: '/saved-cart/email/:email',
  HOME_SAVED_CART: '/saved-cart',
  ...getDeepLinkPaths(),
  ...getEmailLinkPaths()
};

const HOME_ROUTE_CONFIG = {
  template: home,
  controller: 'HomeCtrl',
  controllerAs: 'home',
  jobRequired: false,
  orderRequired: false,
  orderFlow: false
};

function getHomeRoutes() {
  const routes = Object.entries(HOME_PATHS).reduce((acc, [key, path]) => {
    return {
      ...acc,
      [key]: {
        path,
        ...HOME_ROUTE_CONFIG
      }
    };
  }, {});

  routes.HOME.gotoName = 'goToHome';

  return routes;
}

export const homeRoutes = getHomeRoutes();
